export default "__VITE_ASSET__CQWquqHf__"